import type { EvidencePayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import DocumentFieldEvidenceView from '@UI/Store/Documents/Views/DocumentFieldEvidenceView';
import FactEvidenceView from '@UI/Store/Documents/Views/FactEvidenceView';
import ImportedDocumentEvidenceView from '@UI/Store/Documents/Views/ImportedDocumentEvidenceView';
import TurnEvidenceView from '@UI/Store/Documents/Views/TurnEvidenceView';

export type DocumentEvidenceView =
	| TurnEvidenceView
	| FactEvidenceView
	| DocumentFieldEvidenceView
	| ImportedDocumentEvidenceView;

/** Resolves the evidence union straight off the wire discriminant `type`; an unknown `type` fails
 * to compile rather than falling back to another view. */
const buildDocumentEvidenceView = (payload: EvidencePayload): DocumentEvidenceView => {
	switch (payload.type) {
		case 'turn':
			return new TurnEvidenceView(payload);
		case 'fact':
			return new FactEvidenceView(payload);
		case 'document_field':
			return new DocumentFieldEvidenceView(payload);
		case 'imported_document':
			return new ImportedDocumentEvidenceView(payload);
		default: {
			const exhaustive: never = payload;
			throw new Error(`Unhandled evidence type: ${JSON.stringify(exhaustive)}`);
		}
	}
};

export default buildDocumentEvidenceView;
